import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Card, Flex, Spinner, Text } from '@radix-ui/themes';
import { detectInstallLink, WalletState } from '@rango-dev/ui';
import { useWallets } from '@rango-dev/widget-embedded';
import { useTranslation } from 'react-i18next';
export function WalletItem(props) {
    const { wallet, handleClick, disabled, disablePartialState } = props;
    const { title, image, link } = wallet;
    const { t } = useTranslation();
    const { state } = useWallets();
    const notInstalled = wallet.state === WalletState.NOT_INSTALLED;
    function renderConnectingState() {
        return (_jsxs(Flex, { align: "center", gap: "1", children: [_jsx(Spinner, { size: "1" }), _jsx(Text, { size: "1", color: "blue", weight: "medium", children: t('Connecting...') })] }));
    }
    function renderConnectedState() {
        return (_jsx(Text, { size: "1", weight: "medium", style: { color: 'var(--green-11)' }, children: t('Connected') }));
    }
    function renderPartiallyConnectedState() {
        if (!disablePartialState) {
            return (_jsx(Text, { size: "1", color: "orange", weight: "medium", children: t('Partially-connected') }));
        }
        const namespacesState = state(wallet.type)?.namespaces;
        if (!namespacesState ||
            !Array.from(namespacesState.values()).some((namespace) => namespace.connecting)) {
            return renderConnectedState();
        }
        return renderConnectingState();
    }
    function renderWalletState() {
        switch (wallet.state) {
            case WalletState.NOT_INSTALLED:
                return (_jsx(Text, { size: "1", weight: "medium", style: { color: 'var(--cyan-10)' }, children: t('Install') }));
            case WalletState.DISCONNECTED:
                return (_jsx(Text, { size: "1", weight: "medium", style: { color: 'var(--slate-9)' }, children: t('Detected') }));
            case WalletState.CONNECTING:
                return renderConnectingState();
            case WalletState.PARTIALLY_CONNECTED:
                return renderPartiallyConnectedState();
            case WalletState.CONNECTED:
                return renderConnectedState();
            default:
                return null;
        }
    }
    const body = (_jsxs(Flex, { direction: "column", align: "center", justify: "center", gap: "1", height: "100%", children: [_jsx(Avatar, { src: image, alt: title, fallback: title.charAt(0), size: "2", radius: "medium" }), _jsxs(Flex, { direction: "column", align: "center", children: [_jsx(Text, { size: "2", weight: "bold", align: "center", truncate: true, style: { color: 'var(--slate-a11)' }, children: title }), renderWalletState()] })] }));
    if (notInstalled) {
        return (_jsx(Card, { asChild: true, variant: "surface", className: "connect-wallet-item", children: _jsx("a", { href: detectInstallLink(link), target: "_blank", rel: "noreferrer", children: body }) }));
    }
    return (_jsx(Card, { asChild: true, variant: "surface", className: "connect-wallet-item", children: _jsx("button", { id: `connect-wallet-item-${wallet.type}-btn`, type: "button", disabled: disabled, onClick: () => handleClick(wallet), children: body }) }));
}
